import { useState, useEffect, FunctionComponent } from "react"
import { loadStripe } from "@stripe/stripe-js";
import { useSearchParams } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { stripe } from "src/utils";
import AppointmentCheckoutForm from "src/components/forms/stripe/AppointmentCheckoutForm";
import { LoadingSpinner } from "src/components/generic";

const PayAndBook: FunctionComponent = () => {
    const key = process.env.REACT_APP_STRIPE_ACCESS_KEY || '';
    const prod = process.env.REACT_APP_ENV === 'prod';

    const [params] = useSearchParams();

    const stripePromise = loadStripe(key);
    const customerId = params.get('scid');
    const appointmentType = params.get('type');
    const productId = prod ? appointmentType === 'ia' ? 'prod_RbeQL5Mqz9blvi' : 'prod_RbeRO37Yfe217K' // prod_id = product NOT production
                           : appointmentType === 'ia' ? 'prod_Qp9GGUBN2oAnRV' : 'prod_Qp9HrZoHWbdxYc';

    
    const [clientSecret, setClientSecret] = useState<string | null>(null);
    const [paymentIntentId, setPaymentIntentId] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [elementsKey, setElementsKey] = useState(0); 
    const [discount, setDiscount] = useState<number>(0);
    const [amount, setAmount] = useState<number>(0);
    const [error, setError] = useState<string>('');

    const fetchClientSecret = async () => {
        setLoading(true);
        if (!customerId) return;

        try {
            const result = await stripe.payments.createPaymentIntent(customerId, productId, discount);

            setPaymentIntentId(result?.piId?.id)
            setAmount(result?.originalAmount);
            setClientSecret(result?.clientSecret);
            setElementsKey(prevKey => prevKey + 1);
        } catch(error: any) {
            setError(error?.message || 'Failed to Fetch Client')
        } finally {
            setLoading(false);
        }
    }

    const updatePaymentIntent = async (newAmount: number) => {
        setLoading(true);
        if (!customerId || !paymentIntentId || !newAmount) return;

        try {
            const result = await stripe.payments.updatePaymentIntent(paymentIntentId, newAmount);

            setClientSecret(result?.clientSecret)
            setAmount(result?.finalAmount);
        } catch (error: any) {
            setError(error?.message || 'Failed to Update Intent')
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchClientSecret();
    }, [customerId]);

    if(loading) return <LoadingSpinner />
    return (
        <div className="w-full mt-4">
            {error && <p>{error}</p>}
            <div>
            {clientSecret && (
                <Elements key={elementsKey} options={{clientSecret, appearance: {theme: 'stripe'}, loader: 'auto'}} stripe={stripePromise}>
                        <AppointmentCheckoutForm
                            amount={amount} type={appointmentType === 'ia' ? 'intake' : 'followup'}
                            updatePaymentIntent={updatePaymentIntent}
                        />
                </Elements>
            )}
            </div>
        </div>
    )
}

export default PayAndBook;